export const STEP_STATE = {
  // Current step
  CURRENT: 'STEP_STATE_CURRENT',

  // Previous step to current
  PREVIOUS: 'STEP_STATE_PREVIOUS',

  // Later step not yet visited
  LATER_NEW: 'STEP_STATE_LATER_NEW',

  // Later step that doesn't have validation (eg Pay and Post)
  LATER_NO_VALIDATION: 'STEP_STATE_LATER_NO_VALIDATION',

  // Later step that has been visited and is invalid
  LATER_INVALID: 'STEP_STATE_LATER_INVALID',

  // Later step that has been visited and is valid
  LATER_VALID: 'STEP_STATE_LATER_VALID',
};

export const ICON_STATE = {
  BLUE_DOT: 'ICON_STATE_BLUE_DOT',
  BLUE_TICK: 'ICON_STATE_BLUE_TICK',
  GRAY_CIRCLE: 'ICON_STATE_GRAY_CIRCLE',
  GRAY_CIRCLE_FILLED: 'ICON_STATE_GRAY_CIRCLE_FILLED',
  GRAY_TICK: 'ICON_STATE_GRAY_TICK',
};

export const LINE_STATE = {
  GRAY_DOTTED_LINE: 'LINE_STATE_GRAY_DOTTED_LINE',
  BLUE_LINE: 'LINE_STATE_BLUE_LINE',
  GRAY_LINE: 'LINE_STATE_GRAY_LINE',
};
